module.exports = __webpack_public_path__ + "20250721160708/img/one.a9fbf37d.png";